//@flow
import * as types from "./types";

export const displayedProjectTour = () => ({
  type: types.PROJECT_TOUR_DISPLAYED
});
